export enum GoalType {
  CUSTOMER = "customer",
  BOAT = "boat"
}